const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Rajdhani:wght@400;500;600;700&family=Orbitron:wght@400;600;700;900&display=swap');

  .comp-section {
    position: relative;
    z-index: 1;
    min-height: 80vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 100px 4rem 80px;
    font-family: 'Rajdhani', sans-serif;
  }

  .comp-container {
    width: 100%;
    max-width: 1100px;
    margin: 0 auto;
  }

  .comp-header {
    text-align: center;
    margin-bottom: 4rem;
  }

  .comp-label {
    font-family: 'Orbitron', monospace;
    font-size: 0.65rem;
    font-weight: 600;
    color: #ff8c00;
    letter-spacing: 5px;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    margin-bottom: 1rem;
    opacity: 0;
    animation: compFadeUp 0.7s ease 0.1s both;
  }
  .comp-label::before, .comp-label::after { content: ''; width: 50px; height: 1px; }
  .comp-label::before { background: linear-gradient(to right, transparent, #ff8c00); }
  .comp-label::after  { background: linear-gradient(to left,  transparent, #ff8c00); }

  .comp-title {
    font-family: 'Orbitron', monospace;
    font-size: clamp(1.8rem, 4vw, 2.8rem);
    font-weight: 900;
    background: linear-gradient(135deg, #ffffff 0%, #38c8ff 60%, #00aaff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    filter: drop-shadow(0 0 20px rgba(0,170,255,0.3));
    opacity: 0;
    animation: compFadeUp 0.7s ease 0.2s both;
  }

  /* TABLE STYLE */
  .comp-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    opacity: 0;
    animation: compFadeUp 0.7s ease 0.3s both;
  }

  .comp-item {
    background: rgba(0, 20, 50, 0.5);
    border: 1px solid rgba(0,170,255,0.12);
    border-left: 2px solid #00aaff;
    padding: 1.4rem 1.8rem;
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 1rem;
    align-items: center;
    position: relative;
    transition: all 0.3s;
  }

  .comp-item:hover {
    border-color: rgba(0,170,255,0.4);
    box-shadow: 0 0 20px rgba(0,170,255,0.08);
    transform: translateX(4px);
  }

  .comp-item-left {}

  .comp-item-name {
    font-family: 'Orbitron', monospace;
    font-size: 0.85rem;
    font-weight: 700;
    color: #e8f4ff;
    margin-bottom: 0.3rem;
  }

  .comp-item-org {
    font-size: 0.88rem;
    color: #00aaff;
    font-weight: 600;
    margin-bottom: 0.2rem;
  }

  .comp-item-role {
    font-size: 0.83rem;
    color: rgba(232,244,255,0.45);
  }

  .comp-item-right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.4rem;
  }

  .comp-item-year {
    font-family: 'Orbitron', monospace;
    font-size: 0.65rem;
    color: #4a7a9b;
    letter-spacing: 1px;
  }

  .comp-award {
    display: inline-block;
    background: rgba(255,140,0,0.1);
    border: 1px solid rgba(255,140,0,0.3);
    border-radius: 3px;
    padding: 0.2rem 0.7rem;
    font-family: 'Orbitron', monospace;
    font-size: 0.55rem;
    color: #ffaa33;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .comp-award.no-award {
    background: rgba(0,170,255,0.05);
    border-color: rgba(0,170,255,0.15);
    color: #4a7a9b;
  }

  @keyframes compFadeUp {
    from { opacity: 0; transform: translateY(24px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  @media (max-width: 900px) {
    .comp-section { padding: 100px 2rem 60px; }
    .comp-item { grid-template-columns: 1fr; }
    .comp-item-right { align-items: flex-start; }
  }
`;

const COMPETITIONS = [
  {
    name: "COE-ECO Climathon",
    org: "BS Computer Engineering",
    role: "Participant / Presentor",
    year: "2026",
    award: "Participant",
  },
  {
    name: "BRAVEVOLUTION",
    org: "FAITH Colleges – CPE Department",
    role: "Player - Basketball Mens",
    year: "2023-2026",
    award: "Player",
  },
  {
    name: "SHS Science & Technology Fair",
    org: "Malvar Senior High School",
    role: "Project Presenter / Marshal",
    year: "2023",
    award: "Best in Capstone",
  },
  {
    name: "Junior High School Lasallian Cup",
    org: "Junior High School",
    role: "Player",
    year: "2017",
    award: "Participant",
  },
  {
    name: "CPELYMPICS",
    org: "Institute of Computer Engineering of the Philippines Student Edition - FAITH CHAPTER",
    role: "Player",
    year: "2026",
    award: "Participant",
  },
];

export default function Competitions() {
  return (
    <section className="comp-section" id="competitions">
      <style>{styles}</style>
      <div className="comp-container">

        <div className="comp-header">
          <p className="comp-label">Events & Contests</p>
          <h2 className="comp-title">Competitions Joined</h2>
        </div>

        <div className="comp-list">
          {COMPETITIONS.map((c, i) => (
            <div className="comp-item" key={i}>
              <div className="comp-item-left">
                <p className="comp-item-name">{c.name}</p>
                <p className="comp-item-org">{c.org}</p>
                <p className="comp-item-role">{c.role}</p>
              </div>
              <div className="comp-item-right">
                <span className="comp-item-year">{c.year}</span>
                <span className={`comp-award ${c.award === "Participant" ? "no-award" : ""}`}>
                  {c.award}
                </span>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}